import { regStepsData } from '@/data/landing/RegStepsData'

const steps = [
  regStepsData.regApply,
  regStepsData.regIdentity,
  regStepsData.regAmount,
  regStepsData.regReview,
  regStepsData.regRecharge
]

const RegStepsSection = () => {
  return (
    <section id="process" className="w-full py-12 tablet:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 tablet:px-6 desktop:px-8">
        <div className="mb-8 text-center">
          <div className="mb-3 inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-600">
            فرآیند ثبت‌نام
          </div>
          <h2 className="text-2xl font-black text-slate-900 tablet:text-3xl">
            فقط ۵ مرحله تا فروش در آپولون
          </h2>
        </div>

        <div className="grid gap-5 lg:grid-cols-2 xl:grid-cols-5">
          {steps.map((step) => {
            const Icon = step.RightIcon

            return (
              <div
                key={step.id}
                className="group relative rounded-[28px] border border-slate-200 bg-white p-5 shadow-[0_12px_30px_rgba(15,23,42,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(15,23,42,0.08)]"
              >
                <div className="absolute -right-2 top-4 flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-sm font-black text-white shadow-sm">
                  {step.id}
                </div>

                <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-50 text-primary-600">
                  <Icon width={30} height={30} />
                </div>

                <h3 className="mb-3 text-right text-lg font-bold text-slate-900">
                  {step.title}
                </h3>

                <p className="text-right text-sm leading-7 text-slate-600">
                  {step.text}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default RegStepsSection
